import { ReactNode } from 'react'
import { Input } from '@/components/ui/input'
import { Search } from 'lucide-react'

interface ListPageLayoutProps {
  /** Search query value */
  searchQuery?: string
  /** Search query change handler */
  onSearchChange?: (query: string) => void
  /** Search placeholder text */
  searchPlaceholder?: string
  /** Filter controls to render */
  filters?: ReactNode
  /** Tab controls to render */
  tabs?: ReactNode
  /** Main content to render */
  children: ReactNode
  /** Additional actions to render next to search */
  actions?: ReactNode
}

export function ListPageLayout({
  searchQuery,
  onSearchChange,
  searchPlaceholder = 'Search...',
  filters,
  tabs,
  children,
  actions,
}: ListPageLayoutProps) {
  return (
    <div className="space-y-3">
      <div className="space-y-4 mt-6">
        {/* Search Bar */}
        {searchQuery !== undefined && onSearchChange && (
          <div className="flex flex-col sm:flex-row gap-2">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
              <Input
                type="text"
                placeholder={searchPlaceholder}
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
                className="pl-10"
              />
            </div>
            {actions && <div className="w-full sm:w-auto">{actions}</div>}
          </div>
        )}

        {/* Filters */}
        {filters && <div>{filters}</div>}
      </div>

      {tabs && <div className="mt-6 mb-6">{tabs}</div>}

      {/* Content */}
      <div>{children}</div>
    </div>
  )
}
